import { CostAccountingArray } from '../../../types/costAccounting/CostAccountingGetResponse';
import { formatProjectName } from '../../../utils/formatProjectName';

interface RenderCostAccountingRowProps {
  item: CostAccountingArray;
}

const RenderCostAccountingRow = ({ item }: RenderCostAccountingRowProps) => {
  return (
    <>
      <td>{item.projectNumber}</td>
      <td>{formatProjectName(item.projectName)}</td>
      <td>{new Date(item.startDate).toLocaleDateString('ja-JP')}</td>
      <td>{new Date(item.endDate).toLocaleDateString('ja-JP')}</td>
      <td>{Number(item.totalCost).toLocaleString('ja-JP')}</td>
      <td>{Number(item.mahHoursCost).toLocaleString('ja-JP')}</td>
      <td>{Number(item.dairenSubcontractingCost).toLocaleString('ja-JP')}</td>
      <td>{Number(item.otherSubcontractingCost).toLocaleString('ja-JP')}</td>
      <td>{Number(item.expenses).toLocaleString('ja-JP')}</td>
      <td>{item.manHoursTotal}</td>
    </>
  );
};

export default RenderCostAccountingRow;
